<template>
	<div class="all-history">
		<div class="all-history__head">
			<button class="all-history__tab" :class="[activeTab === 'results' ? 'active' : '']" @click="selectTab('results')">История игр</button>
			<button class="all-history__tab" :class="[activeTab === 'wins' ? 'active' : '']" @click="selectTab('wins')">Большие выигрыши</button>
		</div>
		<div class="all-history__table-area no-scrollbar">
			<table class="all-history__table">
				<tbody>
				<tr class="all-history__tr" v-for="game in activeTab === 'wins' ? this.wins : this.results" @click="activeTab === 'wins' ? showGame(game.id, game.game) : null" :key="game.id">
					<td>
						<span class="all-history__name">{{ game.username }}</span>
					</td>
					<td>{{ parseFloat(game.bet).toFixed(2) }}</td>
					<td v-if="game.game === 'dice'">
						<span class="all-history__chance">{{ (100 / game.chance).toFixed(2) }}</span>
					</td>
					<td v-else>
						<span class="all-history__chance">{{ (game.chance).toFixed(2) }}</span>
					</td>
					<td>
						<span class="all-history__win" :class="[`all-history__win--${game.win > 0 ? 'success' : 'danger'}`]">
							{{ parseFloat(game.win).toFixed(2) }}
						</span>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
    export default {
        // props: ['myGames'],
        data() {
            return {
                activeTab: 'results',
                tableLength: 10,
                minWinAmount: 150,
                maxWinAmount: 100000,
                firstRun: true,
            }
        },
        mounted() {
			this.fillTable();
		},
        computed: {
            results: {
                get: function() {
                    return this.$root.history.results;
                },
                set: function(games) {
                    this.$root.history.results = games;
                }
            },
            wins: {
                get: function() {
                    return this.$root.history.wins;
                },
                set: function(games) {
                    this.$root.history.wins = games;
                }
            },
            history: {
                set: function(game) {
                    if (this.$root.history.results.length >= this.tableLength) {
                        this.$root.history.results.pop();
                    }

                    this.$root.history.results.unshift(game);

                    if(game.win - game.bet >= this.minWinAmount && game.win - game.bet < this.maxWinAmount) {
                        if (this.$root.history.wins.length >= this.tableLength) {
                            this.$root.history.wins.pop();
                        }

                        this.$root.history.wins.unshift(game);
                    }
                },
                get: function() {
                    return this.$root.history;
                }
            }
        },
        methods: {
            fillTable() {
                this.$socket.emit('gameHistory', (data) => {
                    this.results = data.games.length ? data.games : [];
                    this.wins = data.wins.length ? data.wins : [];
                });
            },
            showGame(id, game) {
                this.$root.emitter.emit('showGame', {
                    id: id, 
                    game: game
                });
            },
            selectTab(tab) {
                if (tab === this.activeTab) {
                    return;
                }

                this.activeTab = tab;
            }
        },
        sockets: {
            newGame(game) {
                this.history = game;
            }
        }
    }
</script>
